import React from "react";

export const AddressSummarySection = ({ formData }) => (
  <div className="summary-section">
    <h4>Address Information</h4>
    <div className="summary-row">
      <span className="summary-label">Country:</span>
      <span className="summary-value">{formData.country}</span>
    </div>
    {formData.state && (
      <div className="summary-row">
        <span className="summary-label">State:</span>
        <span className="summary-value">{formData.state}</span>
      </div>
    )}
    {formData.city && (
      <div className="summary-row">
        <span className="summary-label">City:</span>
        <span className="summary-value">{formData.city}</span>
      </div>
    )}
    {formData.pincode && (
      <div className="summary-row">
        <span className="summary-label">Pincode:</span>
        <span className="summary-value">{formData.pincode}</span>
      </div>
    )}
    {formData.address && (
      <div className="summary-row">
        <span className="summary-label">Address:</span>
        <span className="summary-value">{formData.address}</span>
      </div>
    )}
  </div>
);
